import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';

/**
 * Ranked list with hairline dividers — the "Top Performing Template" pattern.
 * Rows stagger in so the list assembles rather than appearing all at once.
 */
const TopContentList = ({ title, items, emptyLabel, loading }) => (
  <div className="bg-white dark:bg-shoorah-darkBgTabColor border-[1.5px] border-shoorah-borderGray dark:border-shoorah-darkBorder rounded-2xl p-4 md:p-5 flex flex-col h-full">
    <h4 className="text-base font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg mb-1">
      {title}
    </h4>

    {loading || !items?.length ? (
      <div className="flex-1 flex items-center justify-center min-h-[120px]">
        <span className="text-xs text-shoorah-gray3">{loading ? 'Loading…' : emptyLabel}</span>
      </div>
    ) : (
      <ul className="flex flex-col">
        {items.map((item, index) => (
          <motion.li
            key={`${item.title}-${index}`}
            initial={{ opacity: 0, x: -6 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3, delay: index * 0.06 }}
            className="flex items-center justify-between gap-3 py-[10px] border-b border-shoorah-borderGray dark:border-shoorah-darkBorder last:border-b-0"
          >
            <span className="text-sm text-shoorah-lightBlack dark:text-shoorah-darkBg truncate">
              {item.title}
            </span>
            {item.count !== null && item.count !== undefined ? (
              <span className="text-xs font-semibold text-shoorah-gray3 tabular-nums flex-shrink-0">
                {Number(item.count).toLocaleString()}
              </span>
            ) : null}
          </motion.li>
        ))}
      </ul>
    )}
  </div>
);

TopContentList.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      count: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  ),
  emptyLabel: PropTypes.string,
  loading: PropTypes.bool
};

TopContentList.defaultProps = {
  emptyLabel: 'Nothing to show yet'
};

export default TopContentList;
